import { dataMember, required, typedArray } from 'santee-dcts';
import { Age } from './age';
import { siteDisplayNameRenderer } from '../renderer/site-display-name-renderer';

export class Subject {

    @dataMember()
    @required()
    public ctSubjectId: number;

    @dataMember()
    @required()
    public zcSubjectId: string;

    @dataMember()
    @required({ nullable: true })
    public subjectNumber: string;

    @dataMember()
    @required({ nullable: true})
    public screeningNumber: string;

    @dataMember()
    @required({ nullable: true })
    public initials: string;

    @dataMember()
    @required({ nullable: true })
    public status: string;

    @dataMember()
    @required({ nullable: true })
    public sex: string;

    @dataMember()
    @required({ nullable: true })
    public age: Age;

    @dataMember()
    @required({ nullable: true })
    public ageProjectDisplayValue: string;

    @dataMember()
    @required({ nullable: true })
    public isAgeProject: boolean;

    @dataMember()
    @required({ nullable: true })
    public siteNumber: string;

    @dataMember()
    @required({ nullable: true })
    public investigatorName: string;

    @dataMember()
    public hasSubjectDataRevision: boolean;

    public get siteDisplayName() {
        return siteDisplayNameRenderer({siteNumber: this.siteNumber, investigatorFullName: this.investigatorName});
    }
}

export class SubjectsReadModel {
    @dataMember()
    @required()
    @typedArray(Subject)
    public subjects: Subject[];
}

export class SubjectReadModel {
    @dataMember()
    @required({ nullable: true })
    public subject: Subject;
}